"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const PlayArrow_1 = __importDefault(require("@mui/icons-material/PlayArrow"));
const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
const Save_1 = __importDefault(require("@mui/icons-material/Save"));
const Circle_1 = __importDefault(require("@mui/icons-material/Circle"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Slide_1 = __importDefault(require("./common/Slide"));
// PPT Configuration
const pptConfig = [
    {
        id: "slide-1",
        title: "Introduction to AI",
        components: [
            {
                type: "text",
                component: "CustomTextEditor",
                props: {
                    initialX: 100,
                    initialY: 50,
                    initialWidth: 1200,
                    initialHeight: 150,
                    fontFamily: "Arial, sans-serif",
                    fontSize: "48px",
                    textColor: "#1a1a1a",
                    backgroundColor: "transparent",
                    textAlign: "center",
                    lineHeight: "1.2",
                    text: "<h1 style='font-size: 48px; font-weight: bold;'>Introduction to Artificial Intelligence</h1>"
                }
            },
            {
                type: "text",
                component: "CustomTextEditor",
                props: {
                    initialX: 100,
                    initialY: 220,
                    initialWidth: 1200,
                    initialHeight: 100,
                    fontFamily: "Georgia, serif",
                    fontSize: "24px",
                    textColor: "#555555",
                    backgroundColor: "transparent",
                    textAlign: "center",
                    lineHeight: "1.5",
                    text: "<p style='font-size: 24px;'>Exploring the Future of Technology</p>"
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "shape-1",
                    type: "circle",
                    x: 200,
                    y: 400,
                    width: 120,
                    height: 120,
                    fill: "#3b82f6",
                    stroke: "#1e40af",
                    strokeWidth: 3,
                    text: "AI"
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "shape-2",
                    type: "circle",
                    x: 650,
                    y: 400,
                    width: 120,
                    height: 120,
                    fill: "#10b981",
                    stroke: "#059669",
                    strokeWidth: 3,
                    text: "ML"
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "shape-3",
                    type: "circle",
                    x: 1100,
                    y: 400,
                    width: 120,
                    height: 120,
                    fill: "#f59e0b",
                    stroke: "#d97706",
                    strokeWidth: 3,
                    text: "DL"
                }
            },
            {
                type: "image",
                component: "CustomImageEditor",
                props: {
                    initialX: 100,
                    initialY: 550,
                    width: 350,
                    height: 220,
                    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=400&q=80",
                    borderRadius: "12px",
                    borderWidth: "3px",
                    borderStyle: "solid",
                    borderColor: "#3b82f6",
                    isResizable: true,
                    isDraggable: true
                }
            },
            {
                type: "table",
                component: "CustomTableEditor",
                props: {
                    defaultX: 550,
                    defaultY: 550,
                    editorWidth: 700,
                    editorHeight: 220,
                    defaultRows: 4,
                    defaultCols: 3,
                    defaultValue: [
                        ["Technology", "Impact", "Adoption"],
                        ["Machine Learning", "High", "Growing"],
                        ["Neural Networks", "Very High", "Moderate"],
                        ["AI Assistants", "Medium", "High"]
                    ]
                }
            }
        ]
    },
    {
        id: "slide-2",
        title: "Key Features",
        components: [
            {
                type: "text",
                component: "CustomTextEditor",
                props: {
                    initialX: 100,
                    initialY: 50,
                    initialWidth: 1200,
                    initialHeight: 100,
                    fontFamily: "Arial, sans-serif",
                    fontSize: "42px",
                    textColor: "#1e40af",
                    backgroundColor: "transparent",
                    textAlign: "left",
                    lineHeight: "1.2",
                    text: "<h2 style='font-size: 42px; font-weight: bold;'>Key Features of AI</h2>"
                }
            },
            {
                type: "text",
                component: "CustomTextEditor",
                props: {
                    initialX: 100,
                    initialY: 180,
                    initialWidth: 600,
                    initialHeight: 400,
                    fontFamily: "Arial, sans-serif",
                    fontSize: "20px",
                    textColor: "#333333",
                    backgroundColor: "transparent",
                    textAlign: "left",
                    lineHeight: "1.8",
                    text: `
            <ul style='font-size: 20px; line-height: 1.8;'>
              <li><strong>Machine Learning</strong> - Learn from data</li>
              <li><strong>Natural Language Processing</strong> - Understand text</li>
              <li><strong>Computer Vision</strong> - Interpret images</li>
              <li><strong>Robotics</strong> - Automate physical tasks</li>
              <li><strong>Deep Learning</strong> - Neural networks</li>
            </ul>
          `
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "box-1",
                    type: "rounded-rect",
                    x: 800,
                    y: 200,
                    width: 400,
                    height: 120,
                    fill: "#dbeafe",
                    stroke: "#3b82f6",
                    strokeWidth: 2,
                    cornerRadius: 10,
                    text: "Automation"
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "box-2",
                    type: "rounded-rect",
                    x: 800,
                    y: 340,
                    width: 400,
                    height: 120,
                    fill: "#d1fae5",
                    stroke: "#10b981",
                    strokeWidth: 2,
                    cornerRadius: 10,
                    text: "Intelligence"
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "box-3",
                    type: "rounded-rect",
                    x: 800,
                    y: 480,
                    width: 400,
                    height: 120,
                    fill: "#fef3c7",
                    stroke: "#f59e0b",
                    strokeWidth: 2,
                    cornerRadius: 10,
                    text: "Efficiency"
                }
            }
        ]
    },
    {
        id: "slide-3",
        title: "Applications",
        components: [
            {
                type: "text",
                component: "CustomTextEditor",
                props: {
                    initialX: 100,
                    initialY: 50,
                    initialWidth: 1200,
                    initialHeight: 100,
                    fontFamily: "Arial, sans-serif",
                    fontSize: "42px",
                    textColor: "#7c3aed",
                    backgroundColor: "transparent",
                    textAlign: "center",
                    lineHeight: "1.2",
                    text: "<h2 style='font-size: 42px; font-weight: bold;'>Real-World Applications</h2>"
                }
            },
            {
                type: "image",
                component: "CustomImageEditor",
                props: {
                    initialX: 100,
                    initialY: 180,
                    width: 350,
                    height: 250,
                    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=400&q=80",
                    borderRadius: "10px",
                    borderWidth: "2px",
                    borderStyle: "solid",
                    borderColor: "#7c3aed",
                    isResizable: true,
                    isDraggable: true
                }
            },
            {
                type: "image",
                component: "CustomImageEditor",
                props: {
                    initialX: 500,
                    initialY: 180,
                    width: 350,
                    height: 250,
                    image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80",
                    borderRadius: "10px",
                    borderWidth: "2px",
                    borderStyle: "solid",
                    borderColor: "#10b981",
                    isResizable: true,
                    isDraggable: true
                }
            },
            {
                type: "image",
                component: "CustomImageEditor",
                props: {
                    initialX: 900,
                    initialY: 180,
                    width: 350,
                    height: 250,
                    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=400&q=80",
                    borderRadius: "10px",
                    borderWidth: "2px",
                    borderStyle: "solid",
                    borderColor: "#f59e0b",
                    isResizable: true,
                    isDraggable: true
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "arrow-1",
                    type: "rect",
                    x: 350,
                    y: 550,
                    width: 150,
                    height: 20,
                    fill: "#3b82f6",
                    stroke: "#1e40af",
                    strokeWidth: 3,
                    text: "→"
                }
            },
            {
                type: "shape",
                component: "ShapeEditor",
                props: {
                    id: "arrow-2",
                    type: "rect",
                    x: 750,
                    y: 550,
                    width: 150,
                    height: 20,
                    fill: "#10b981",
                    stroke: "#059669",
                    strokeWidth: 3,
                    text: "→"
                }
            },
            {
                type: "text",
                component: "CustomTextEditor",
                props: {
                    initialX: 100,
                    initialY: 650,
                    initialWidth: 1200,
                    initialHeight: 150,
                    fontFamily: "Arial, sans-serif",
                    fontSize: "18px",
                    textColor: "#666666",
                    backgroundColor: "transparent",
                    textAlign: "center",
                    lineHeight: "1.6",
                    text: "<p style='font-size: 18px;'>Healthcare &nbsp; • &nbsp; Finance &nbsp; • &nbsp; Manufacturing &nbsp; • &nbsp; Transportation &nbsp; • &nbsp; Retail</p>"
                }
            }
        ]
    }
];
const PPTConfigTest = () => {
    var _a;
    const [showPPT, setShowPPT] = (0, react_1.useState)(false);
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const [configText, setConfigText] = (0, react_1.useState)(JSON.stringify(pptConfig, null, 2));
    const [currentConfig, setCurrentConfig] = (0, react_1.useState)(pptConfig);
    const [configError, setConfigError] = (0, react_1.useState)(null);
    // Shape editor state
    const [selectedShape, setSelectedShape] = (0, react_1.useState)(null);
    const [showShapePanel, setShowShapePanel] = (0, react_1.useState)(false);
    const [selectedSlideId, setSelectedSlideId] = (0, react_1.useState)(null);
    const [shapeFormData, setShapeFormData] = (0, react_1.useState)({});
    const handleSaveConfig = () => {
        try {
            const parsed = JSON.parse(configText);
            if (!Array.isArray(parsed)) {
                throw new Error("Configuration must be an array of slides");
            }
            setCurrentConfig(parsed);
            setConfigError(null);
            setIsEditing(false);
        }
        catch (error) {
            setConfigError(error.message || "Invalid JSON format");
        }
    };
    const handleCancelEdit = () => {
        setConfigText(JSON.stringify(currentConfig, null, 2));
        setConfigError(null);
        setIsEditing(false);
    };
    // Handle shape selection for editing
    const handleShapeSelect = (shape, slideId) => {
        setSelectedShape(shape);
        setSelectedSlideId(slideId);
        setShapeFormData(shape.props || {});
        setShowShapePanel(true);
    };
    // Handle form field changes
    const handleFormFieldChange = (field, value) => {
        setShapeFormData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    // Handle shape updates
    const handleShapeUpdate = () => {
        // Update the current config with the updated shape
        const updatedConfig = currentConfig.map((slide) => {
            var _a;
            if (slide.id === selectedSlideId) {
                return Object.assign(Object.assign({}, slide), { components: ((_a = slide.components) === null || _a === void 0 ? void 0 : _a.map((comp) => {
                        var _a, _b;
                        if (comp.component === "ShapeEditor" && ((_a = comp.props) === null || _a === void 0 ? void 0 : _a.id) === ((_b = selectedShape === null || selectedShape === void 0 ? void 0 : selectedShape.props) === null || _b === void 0 ? void 0 : _b.id)) {
                            return Object.assign(Object.assign({}, comp), { props: Object.assign(Object.assign({}, comp.props), shapeFormData) });
                        }
                        return comp;
                    })) || [] });
            }
            return slide;
        });
        setCurrentConfig(updatedConfig);
        setConfigText(JSON.stringify(updatedConfig, null, 2));
        setSelectedShape(Object.assign(Object.assign({}, selectedShape), { props: Object.assign(Object.assign({}, selectedShape.props), shapeFormData) }));
    };
    // Close shape panel
    const handleCloseShapePanel = () => {
        setShowShapePanel(false);
        setSelectedShape(null);
        setSelectedSlideId(null);
        setShapeFormData({});
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { p: 4, maxWidth: "1600px", margin: "0 auto" }, children: [(0, jsx_runtime_1.jsxs)(material_1.Paper, { elevation: 3, sx: { p: 3, mb: 4 }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", gutterBottom: true, sx: { fontWeight: "bold", color: "#1e40af" }, children: "PPT Configuration Test" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", paragraph: true, sx: { color: "#666" }, children: "This page demonstrates rendering PowerPoint slides using the Slide, ImageEditor, and ShapeEditor components. Edit the configuration below to customize your presentation." }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", gap: 2, alignItems: "center", mb: 3, flexWrap: "wrap" }, children: [(0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", size: "large", startIcon: (0, jsx_runtime_1.jsx)(PlayArrow_1.default, {}), onClick: () => setShowPPT(!showPPT), sx: {
                                    bgcolor: "#3b82f6",
                                    "&:hover": { bgcolor: "#2563eb" },
                                    px: 4,
                                    py: 1.5,
                                }, children: showPPT ? "Hide PPT" : "Render PPT" }), !isEditing ? ((0, jsx_runtime_1.jsx)(material_1.Button, { variant: "outlined", size: "large", startIcon: (0, jsx_runtime_1.jsx)(Edit_1.default, {}), onClick: () => setIsEditing(true), sx: { px: 4, py: 1.5 }, children: "Edit Config" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", size: "large", startIcon: (0, jsx_runtime_1.jsx)(Save_1.default, {}), onClick: handleSaveConfig, sx: {
                                            bgcolor: "#10b981",
                                            "&:hover": { bgcolor: "#059669" },
                                            px: 4,
                                            py: 1.5,
                                        }, children: "Save Config" }), (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "outlined", size: "large", onClick: handleCancelEdit, sx: { px: 4, py: 1.5 }, children: "Cancel" })] })), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "body2", sx: { color: "#888" }, children: ["Total Slides: ", currentConfig.length] })] }), configError && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", sx: { mb: 2 }, onClose: () => setConfigError(null), children: configError })), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { bgcolor: "#f8fafc", p: 2, borderRadius: 2, border: "1px solid #e2e8f0" }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", sx: { fontWeight: "bold", mb: 1 }, children: isEditing ? "Edit Configuration:" : "Configuration Preview:" }), isEditing ? ((0, jsx_runtime_1.jsx)(material_1.TextField, { multiline: true, fullWidth: true, value: configText, onChange: (e) => setConfigText(e.target.value), rows: 20, variant: "outlined", sx: {
                                    "& .MuiInputBase-root": {
                                        fontFamily: "monospace",
                                        fontSize: "12px",
                                        bgcolor: "#ffffff",
                                    },
                                }, placeholder: "Paste your PPT configuration JSON here..." })) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", component: "pre", sx: {
                                    fontSize: "11px",
                                    overflow: "auto",
                                    maxHeight: "300px",
                                    display: "block"
                                }, children: JSON.stringify(currentConfig, null, 2) }))] })] }), showPPT && ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { mt: 4 }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", gutterBottom: true, sx: { fontWeight: "bold", mb: 3 }, children: "Presentation Preview" }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            bgcolor: "#f5f5f5",
                            p: 3,
                            borderRadius: 2,
                            border: "2px solid #e0e0e0"
                        }, children: (0, jsx_runtime_1.jsx)(SlideEditorWithConfig, { config: currentConfig, onShapeClick: handleShapeSelect }) })] })), (0, jsx_runtime_1.jsx)(material_1.Drawer, { anchor: "right", open: showShapePanel, onClose: handleCloseShapePanel, sx: {
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                }, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { p: 2, height: "100%", display: "flex", flexDirection: "column" }, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [(0, jsx_runtime_1.jsx)(Circle_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", children: "Shape Editor" })] }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: handleCloseShapePanel, children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) })] }), (0, jsx_runtime_1.jsx)(material_1.Divider, { sx: { mb: 2 } }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { mb: 2 }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", color: "text.secondary", children: "Editing Shape" }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "body2", color: "text.secondary", children: ["Type: ", ((_a = selectedShape === null || selectedShape === void 0 ? void 0 : selectedShape.props) === null || _a === void 0 ? void 0 : _a.type) || 'Unknown'] })] }), (0, jsx_runtime_1.jsx)(material_1.Divider, { sx: { mb: 2 } }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { flex: 1, overflow: "auto" }, children: selectedShape && ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { p: 2, display: "flex", flexDirection: "column", gap: 2 }, children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, { fullWidth: true, children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: "Shape Type" }), (0, jsx_runtime_1.jsxs)(material_1.Select, { value: shapeFormData.type || 'rect', onChange: (e) => handleFormFieldChange('type', e.target.value), children: [(0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: "rect", children: "Rectangle" }), (0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: "circle", children: "Circle" }), (0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: "triangle", children: "Triangle" }), (0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: "diamond", children: "Diamond" }), (0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: "oval", children: "Oval" }), (0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: "rounded-rect", children: "Rounded Rectangle" })] })] }), (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Text Content", value: shapeFormData.text || '', onChange: (e) => handleFormFieldChange('text', e.target.value), multiline: true, rows: 3 }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", gap: 2 }, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Fill Color", value: shapeFormData.fill || '#3b82f6', onChange: (e) => handleFormFieldChange('fill', e.target.value), type: "color" }), (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Stroke Color", value: shapeFormData.stroke || '#1e40af', onChange: (e) => handleFormFieldChange('stroke', e.target.value), type: "color" })] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { gutterBottom: true, children: "Stroke Width" }), (0, jsx_runtime_1.jsx)(material_1.Slider, { value: shapeFormData.strokeWidth || 2, onChange: (e, value) => handleFormFieldChange('strokeWidth', value), min: 0, max: 10, step: 1, marks: true, valueLabelDisplay: "auto" })] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", gap: 2 }, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Width", type: "number", value: shapeFormData.width || 120, onChange: (e) => handleFormFieldChange('width', parseInt(e.target.value) || 120) }), (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Height", type: "number", value: shapeFormData.height || 120, onChange: (e) => handleFormFieldChange('height', parseInt(e.target.value) || 120) })] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", gap: 2 }, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "X Position", type: "number", value: shapeFormData.x || 0, onChange: (e) => handleFormFieldChange('x', parseInt(e.target.value) || 0) }), (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Y Position", type: "number", value: shapeFormData.y || 0, onChange: (e) => handleFormFieldChange('y', parseInt(e.target.value) || 0) })] }), (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Text Color", value: shapeFormData.textFill || '#000000', onChange: (e) => handleFormFieldChange('textFill', e.target.value), type: "color" })] })) }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { mt: 2, pt: 2, borderTop: "1px solid #e0e0e0" }, children: [(0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleCloseShapePanel, variant: "outlined", fullWidth: true, sx: { mb: 1 }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleShapeUpdate, variant: "contained", fullWidth: true, children: "Save Changes" })] })] }) })] }));
};
// Wrapper to accept config as prop
const SlideEditorWithConfig = ({ config, onShapeClick }) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            width: "100%",
            background: "#f5f5f5",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "40px",
        }, children: (0, jsx_runtime_1.jsx)(Slide_1.default, { config: config, onShapeClick: onShapeClick }) }));
};
exports.default = PPTConfigTest;
